// Shared form-field validators. Pure functions, no React, no Supabase.
// Each validator returns null when valid or a short user-facing message.

const USERNAME_RE = /^[A-Za-z0-9_]+$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateUsername(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return 'Pick a username.';
  if (trimmed.length < 3) return 'Username must be at least 3 characters.';
  if (trimmed.length > 20) return 'Username must be 20 characters or fewer.';
  if (!USERNAME_RE.test(trimmed)) {
    return 'Letters, numbers, and underscores only.';
  }
  return null;
}

export function validateEmail(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return 'Enter your email.';
  if (!EMAIL_RE.test(trimmed)) return 'Enter a valid email address.';
  return null;
}

export function validatePassword(value: string): string | null {
  if (!value) return 'Choose a password.';
  if (value.length < 8) return 'Password must be at least 8 characters.';
  if (!/\d/.test(value)) return 'Password must contain at least one number.';
  return null;
}

export function validatePasswordMatch(password: string, confirm: string): string | null {
  if (!confirm) return 'Confirm your password.';
  if (password !== confirm) return 'Passwords do not match.';
  return null;
}

// Character name validation. Allowed characters mirror what the game's
// design docs describe: letters, numbers, spaces, apostrophes, hyphens,
// periods. The trim is intentional - leading or trailing whitespace would
// look like a different name in the harbor logs.
const CHARACTER_NAME_RE = /^[A-Za-z0-9 '\-.]+$/;

export function validateCharacterName(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return 'Pick a name.';
  if (trimmed.length < 2) return 'Name must be at least 2 characters.';
  if (trimmed.length > 30) return 'Name must be 30 characters or fewer.';
  if (!CHARACTER_NAME_RE.test(trimmed)) {
    return 'Letters, numbers, spaces, apostrophes, hyphens, and periods only.';
  }
  // Disallow runs of whitespace and leading/trailing punctuation that
  // would render as a malformed name.
  if (/\s{2,}/.test(trimmed)) {
    return 'Single spaces only.';
  }
  return null;
}
